import { Link, Title, useResourceDefinitions, useTranslate } from 'react-admin';

import { PageTitle } from '@sh4res/bo-common/components/PageTitle';
import { Resources } from '@sh4res/bo-common/utils';
import { buildLink } from '@sh4res/bo-common/utils/build_link';

import { TranslationKeys } from '@I18n/types';

export const Sitemap = () => {
  const translate = useTranslate();
  const resources = useResourceDefinitions();

  const translatedTitle = translate('footer.links_label.sitemap');

  return (
    <>
      <PageTitle title={translatedTitle} />
      <Title title={translatedTitle} />
      <div style={{ width: '100%', height: '100%' }}>
        <nav>
          <ul style={{ paddingLeft: '1.5rem', margin: 0 }}>
            {Object.values(resources).map((resource) =>
              resource.hasList ? (
                <li key={resource.name} style={{ marginBottom: '0.5rem' }}>
                  <Link to={buildLink(resource.name as Resources, 'list')}>
                    {translate((resource.options?.label ?? resource.name) as TranslationKeys)}
                  </Link>
                </li>
              ) : null,
            )}
          </ul>
        </nav>
      </div>
    </>
  );
};
